import { render, staticRenderFns } from "./invoicesDetails.vue?vue&type=template&id=34056e55&scoped=true"
import script from "./invoicesDetails.vue?vue&type=script&lang=js"
export * from "./invoicesDetails.vue?vue&type=script&lang=js"
import style0 from "./invoicesDetails.vue?vue&type=style&index=0&id=34056e55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34056e55",
  null
  
)

export default component.exports